export default __webpack_public_path__ + "static/media/confeti.66eae667.svg";